import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getEmployeeZaz } from '@/services/zaz.service';
import ZazSendModal from './ZazSendModal';
import { EMPLOYEE_ZAZ_QUERY_KEY } from './zazKeys';

/**
 * The ZAZ of an employee profile, for HR of the company and the heads of the
 * employee's sector. The server decides (403 for anyone else, always for the
 * employee themselves): a refusal leaves the tile and the action out.
 *
 * @param {Object} params
 * @param {string} params.employeeId
 * @param {string} params.employeeName
 * @param {boolean} params.enabled - Not on one's own profile.
 */
export default function useEmployeeZaz({ employeeId, employeeName, enabled }) {
  const [sendOpen, setSendOpen] = useState(false);

  const { data } = useQuery({
    queryKey: [EMPLOYEE_ZAZ_QUERY_KEY, employeeId],
    queryFn: () => getEmployeeZaz(employeeId),
    enabled: !!employeeId && enabled,
    retry: false,
  });

  const zaz = data || null;
  const canSend = !!zaz?.canSend;
  // The tile exists once there is something to do or to see on it.
  const showTile = !!zaz && (zaz.enabled || zaz.items?.length > 0);

  const modal = canSend ? (
    <ZazSendModal
      open={sendOpen}
      onClose={() => setSendOpen(false)}
      employeeId={employeeId}
      employeeName={employeeName}
      heads={zaz.heads}
    />
  ) : null;

  return {
    zaz,
    canSend,
    showTile,
    openSend: () => setSendOpen(true),
    modal,
  };
}
